import { Progress, SimpleGrid, Text } from "@chakra-ui/react";
import { BrandLayout } from "__generated__/gql/graphql";
import SetupStepTile, {
  OnboardingSetupStep,
} from "components/Onboarding/SetupStepTile";
import { APP_NAME } from "utils/config";
import { useCurrentBrandData } from "utils/currentUserHooks";
import WalkthroughCard from "./WalkthroughCard";

type Props = {
  completedCount: number | undefined;
  onStepClick?: () => void;
  steps: OnboardingSetupStep[];
};

export default function SetupGuideBody({
  completedCount,
  onStepClick,
  steps,
}: Props) {
  const brand = useCurrentBrandData();
  const isAnalyticsLayout = brand?.layout === BrandLayout.ANALYTICS;

  return (
    <>
      <Text color="gray.600" fontSize="sm" fontWeight="400" mb={4}>
        To get the most out of {APP_NAME}
        {isAnalyticsLayout && " Analytics"}, add your products
        {!isAnalyticsLayout && " and your retailers"}.{" "}
        {isAnalyticsLayout
          ? "We’ll use those SKUs to match sales and inventory data across your analytics dashboards."
          : "From there, you’ll unlock submissions, forms, promotions — and so much more."}
      </Text>

      {completedCount !== undefined && (
        <Progress
          value={(completedCount / steps.length) * 100}
          colorScheme="pink"
          size="sm"
          borderRadius="full"
          mb={5}
        />
      )}

      <SimpleGrid
        gridTemplateColumns="repeat(auto-fit, minmax(min(14rem, 100%), 1fr))"
        gap={4}
      >
        {steps.map((step) => (
          <SetupStepTile key={step.id} onClick={onStepClick} step={step} />
        ))}
      </SimpleGrid>

      <WalkthroughCard />
    </>
  );
}
